import Cookies from "js-cookie";
import CookieConsentRepository from "@/api/cookie-consent";

const COOKIE_CONSENT_KEY = "cookieConsent";

export default {
  namespaced: true,

  state() {
    return {
      show: false,
      value: null,
    };
  },

  getters: {
    getId() {
      const valueJson = Cookies.get(COOKIE_CONSENT_KEY);
      if (!valueJson) return null;

      return JSON.parse(valueJson).id;
    },
    getTimestamp() {
      const valueJson = Cookies.get(COOKIE_CONSENT_KEY);
      if (!valueJson) return null;

      return JSON.parse(valueJson).timestamp;
    },
  },

  mutations: {
    setShow(state, value) {
      state.show = value;
    },

    setValue(state, value) {
      state.value = value;
    },
  },

  actions: {
    init({ commit }) {
      const valueJson = Cookies.get(COOKIE_CONSENT_KEY);

      commit("setShow", valueJson == null);

      if (!valueJson) return;
      commit("setValue", JSON.parse(valueJson).type?.analytics === true);
    },

    async changeValue({ commit }, value) {
      await CookieConsentRepository.set({
        consent_state: { analytics: value },
        url: window.location.href,
      });

      commit("setValue", value);
    },
  },
};
